var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 8,
    viewBox: "0 0 32 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2774 2.41603C31.5071 2.26285 31.5692 1.95241 31.416 1.72265C31.2628 1.49289 30.9524 1.4308 30.7227 1.58397L31.2774 2.41603ZM0.901942 1.50971C0.631164 1.56386 0.455554 1.82728 0.509711 2.09806L1.39223 6.51067C1.44639 6.78145 1.7098 6.95706 1.98058 6.9029C2.25136 6.84874 2.42697 6.58533 2.37281 6.31455L1.58835 2.39223L5.51067 1.60777C5.78145 1.55361 5.95706 1.2902 5.9029 1.01942C5.84875 0.748637 5.58534 0.573029 5.31456 0.627185L0.901942 1.50971ZM30.7227 1.58397L29.0354 2.70878L29.5901 3.54083L31.2774 2.41603L30.7227 1.58397ZM2.96455 2.70877L1.27735 1.58397L0.722651 2.41602L2.40985 3.54082L2.96455 2.70877ZM29.0354 2.70878C21.1418 7.9712 10.8582 7.9712 2.96455 2.70877L2.40985 3.54082C10.6394 9.02718 21.3606 9.02718 29.5901 3.54083L29.0354 2.70878Z",
    fill: "#8B997F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow-3.add187fb41605c056041b519887f8a9e.svg";
export { ForwardRef as ReactComponent };